export const getMissingValuesFromList = <T extends string | number>(
  currentValue: T | T[],
  list: Array<{ value?: T | null }>
): T[] => {
  const values = Array.isArray(currentValue) ? currentValue : [currentValue];

  return values.filter((val) => !list.some((item) => item.value === val));
};
